import { useEffect, useState } from 'react';
import { choosePlatform } from '../../helpers/utils';
import { Scouts } from '../../types/types';
import { Captain } from '../Icons/Captain';
import ModalTolltip from '../Modal/Tooltip';

interface Props {
	icon: string | JSX.Element;
	infoIcon: 'warning' | 'success' | 'rules' | '';
	title?: string;
	message?: string | JSX.Element;
	drafPoints?: boolean;
	draftScouts?: any;
	draftResult?: boolean;
	draftResults?: any;
	isCapitan?: boolean;
	disabled?: boolean;
	disableTime?: boolean;
	totalGamesSum?: number;
	average?: number;
	totalScoreSum?: number;
}

export default function Tooltip({
	icon,
	infoIcon,
	title = '',
	message,
	drafPoints = false,
	draftScouts,
	draftResult = false,
	draftResults,
	isCapitan = false,
	disabled = false,
	disableTime = false,
	totalGamesSum,
	average,
	totalScoreSum,
}: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const handleClickOutside = () => setIsOpen(false);

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	useEffect(() => {
		if (disableTime) return;
		if (!isOpen) return;
		const timer = setTimeout(() => {
			setIsOpen(false);
		}, 5000);

		return () => {
			clearTimeout(timer);
		};
	}, [isOpen]);

	return (
		<>
			<button
				onClick={(e: any) => {
					e.stopPropagation();
					if (disabled) return;
					handleClick();
				}}
			>
				{icon}
			</button>

			<ModalTolltip
				id={'modalTooltip'}
				open={isOpen}
				onClose={handleClick}
				infoIcon={infoIcon}
			>
				{!drafPoints && !draftResult ? (
					<>
						{title && (
							<h2 className="text-black text-lg font-semibold font-bahnschrift leading-7">
								{title}
							</h2>
						)}

						{typeof message === 'string' ||
						message instanceof String ? (
							<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
								{message}
							</p>
						) : (
							message
						)}
					</>
				) : drafPoints && !draftResult ? (
					<>
						{title && (
							<h2 className="text-black text-lg font-semibold font-bahnschrift leading-7">
								{title}
							</h2>
						)}
						<div className="grid grid-cols-3 items-center justify-between mb-3">
							{totalScoreSum !== null &&
								totalScoreSum !== undefined && (
									<h2 className="flex max-[375px]:text-base items-center flex-col text-black text-2xl font-semibold font-bahnschrift leading-7">
										<p className="max-[375px]:text-xs max-[395px]:text-sm text-lg">
											Total Acum.
										</p>
										{totalScoreSum.toFixed(2)} pts
									</h2>
								)}
							{totalGamesSum !== null &&
								totalGamesSum !== undefined && (
									<h2 className="flex items-center flex-col text-black max-[375px]:text-xl text-2xl font-semibold font-bahnschrift leading-7">
										<p className="max-[375px]:text-xs max-[395px]:text-sm text-lg">
											Qtd de Jogos
										</p>
										{totalGamesSum}
									</h2>
								)}
							{average !== null && average !== undefined && (
								<h2
									className={`flex items-center flex-col max-[375px]:text-xl text-2xl font-semibold font-bahnschrift leading-7 ${
										Number(average) === 0
											? 'text-black'
											: Number(average) < 0
											? 'text-error'
											: 'text-success'
									}`}
								>
									<p className="text-black max-[375px]:text-xs max-[395px]:text-sm text-lg">
										Media
									</p>
									{average.toFixed(2)} pts
								</h2>
							)}
						</div>
						{typeof message === 'string' ||
						message instanceof String ? (
							<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight pb-2">
								{message}
							</p>
						) : (
							<p className="pb-2">{message}</p>
						)}
						{draftScouts &&
							draftScouts.map((scout: Scouts, index: number) => (
								<div
									key={index}
									className="flex justify-between w-full py-1 px-1"
								>
									<div className="text-[#414651] text-sm font-light font-bahnschrift leading-tight">
										{scout.name}
									</div>
									<div className="text-[#414651] text-sm font-semibold font-bahnschrift leading-tight">
										{scout.points.includes('-')
											? scout.points
											: `+${scout.points}`}{' '}
										pts
									</div>
								</div>
							))}
					</>
				) : (
					<>
						{title && (
							<h2 className="text-black text-lg font-semibold font-bahnschrift leading-7">
								{title}
							</h2>
						)}

						<table className="w-full table-auto">
							<thead className="h-6">
								<tr>
									<th className="text-left self-stretch text-[#414651] text-sm font-medium font-bahnschrift leading-3 tracking-tight"></th>
									<th className="text-right self-stretch w-16 text-[#414651] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
										Pts
									</th>
									<th className="text-right self-stretch w-16 text-[#414651] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
										Quant.
									</th>
									<th className="text-right self-stretch w-16 text-[#414651] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
										Total
									</th>
								</tr>
							</thead>
							<tbody>
								{draftResults &&
									draftResults.map(
										(scout: any, index: number) => (
											<tr key={index}>
												<td
													className={
														'text-[#414651] text-sm font-light font-bahnschrift leading-tight ' +
														(index + 1 ===
														draftResults.length
															? ' pb-1'
															: ' ')
													}
												>
													{scout.scoutName}
												</td>
												<td className="text-[#414651] text-right text-sm font-light font-bahnschrift leading-tight">
													{scout.pointsResult < 0
														? scout.pointsResult
														: `+${scout.pointsResult}`}
												</td>
												<td className="text-[#414651] text-right text-sm font-light font-bahnschrift leading-tight">
													x{scout.scoutsPointsResult}
												</td>
												<td className="text-[#414651] text-right text-sm font-light font-bahnschrift leading-tight">
													{scout.points < 0
														? scout.points
														: `+${scout.points}`}{' '}
													pts
												</td>
											</tr>
										)
									)}
								<tr className="border-t">
									<td className="text-black pt-1 text-sm font-light font-bahnschrift leading-tight">
										Total
									</td>
									<td className="text-black text-right text-sm font-light font-bahnschrift leading-tight"></td>
									<td className="text-black text-right text-sm font-light font-bahnschrift leading-tight"></td>
									<td className="text-black text-right text-sm font-light font-bahnschrift leading-tight">
										{Math.round(
											draftResults.reduce(
												(total: number, scout: any) => {
													let points =
														scout.scoutsPointsResult *
														scout.pointsResult;
													return total + points;
												},
												0
											) * 100
										) / 100}{' '}
										pts
									</td>
								</tr>
								{isCapitan && (
									<tr>
										<td className="text-black text-sm font-light font-bahnschrift leading-tight">
											Capitão
										</td>
										<td className="text-black text-right text-sm font-light font-bahnschrift leading-tight"></td>
										<td className="text-black text-right text-sm font-light font-bahnschrift leading-tight">
											<div className="flex items-end justify-end">
												<Captain
													colorBg="#ffffff"
													colorIcon={
														choosePlatform()
															? '#35168C'
															: '#DF1737'
													}
													className="w-4 h-4 mr-2"
												/>
												x2
											</div>
										</td>
										<td className="text-black text-right text-sm font-light font-bahnschrift leading-tight">
											{(Math.round(
												draftResults.reduce(
													(
														total: number,
														scout: any
													) => {
														let points =
															scout.scoutsPointsResult *
															scout.pointsResult;
														return total + points;
													},
													0
												) * 100
											) /
												100) *
												2}{' '}
											pts
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</>
				)}
			</ModalTolltip>
		</>
	);
}
